export function ORDER_DISPLAY_REQUEST(state) {
  state;
  state.isLoading = true;
}
export function ORDER_DISPLAY_SUCCESS(state, payload) {
  state;
  state.orderDisplays = payload.data;
  state.totalPage = parseInt(payload.headers["x-total-count"]);
  state.isLoading = false;
  state.status = payload.status;
}
export function ORDER_DISPLAY_ERROR(state, payload) {
  state;
  state.isLoading = false;
  state.error = true;
  state.errorMessage = payload;
}
